import Cookies from 'js-cookie';
import { useEffect } from 'react';

import { useAppConfig } from 'src/modules/appConfig';
import { hotjarEvent } from 'src/modules/hotjar';

export const useShareableProfileHotjarEvent = () => {
  const { zone } = useAppConfig();

  useEffect(() => {
    const currCount = Cookies.get('hasSeenShareableProfileCount');
    const newCount = currCount === undefined ? 1 : parseInt(currCount, 10) + 1;

    Cookies.set('hasSeenShareableProfileCount', String(newCount), {
      expires: 365,
    });

    if (newCount > 1 && zone === 'asia-1') {
      hotjarEvent('shareable-profile-sharer-survey');
    }
  }, [zone]);
};
